var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"label":"","small":"","color":_vm.color(_vm.status)}},[_c('small',{staticClass:"white--text"},[_vm._v(_vm._s(this.text(_vm.status)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }